import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CartContext = createContext(null);

const trackEvent = (type, productId) => {
  if (!productId || (typeof productId === "string" && productId.startsWith("tool-"))) return;
  try {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/analytics/event`, { type, product_id: productId }).catch(() => {});
  } catch (_) { /* swallow */ }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("vd-cart");
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem("vd-cart", JSON.stringify(items)); } catch (e) { /* ignore */ }
  }, [items]);

  const addItem = (item, quantity = 1) => {
    trackEvent("cart_add", item.tyre_id);
    setItems((curr) => {
      const idx = curr.findIndex((i) => i.tyre_id === item.tyre_id);
      if (idx >= 0) {
        const copy = [...curr];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...curr, { ...item, quantity }];
    });
  };

  const updateQuantity = (tyre_id, quantity) => {
    setItems((curr) => curr.map((i) => i.tyre_id === tyre_id ? { ...i, quantity: Math.max(1, quantity) } : i));
  };

  const removeItem = (tyre_id) => setItems((curr) => curr.filter((i) => i.tyre_id !== tyre_id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQuantity, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
